import React from "react";
import { CDataTable, CButton } from "@coreui/react";

import { useReservation } from "context/reservationContext";

import * as Constants from "./constants";
import Buttons from "./components/Buttons";

function TableAssistans() {
  const {
    assistants,
    setShowTable,
    handleRemoveAssistant,
    setCurrentAssistant,
  } = useReservation();
  const mapAssistants = () =>
    assistants.map(({ name, typeId, numberId }) => ({
      [Constants.NAME]: name,
      [Constants.CC]: `${typeId} ${numberId}`,
    }));
  const handleEdit = (cc) => {
    setShowTable(false);
    const assistant = assistants.find(
      (ass) => `${ass.typeId} ${ass.numberId}` === cc
    );
    setCurrentAssistant(assistant);
  };
  const handleAddAssistant = () => {
    setCurrentAssistant(null);
    setShowTable(false);
  };
  return (
    <>
      <CDataTable
        items={mapAssistants()}
        fields={Constants.Fields}
        itemsPerPage={5}
        pagination={assistants.length > 5}
        scopedSlots={{
          [Constants.OPTIONS]: (item) => (
            <td>
              <Buttons
                onEdit={() => handleEdit(item[Constants.CC])}
                onRemove={() => handleRemoveAssistant(item[Constants.CC])}
              />
            </td>
          ),
        }}
      />
      {assistants.length < 4 && (
        <CButton onClick={handleAddAssistant} size="sm" color="secondary">
          Agregar familiar
        </CButton>
      )}
    </>
  );
}

export default TableAssistans;
